Global.store.mutations = {
    setShowMediaVideoModal(state, value) {
        state.showMediaVideoModal = value;
    },

    setShowSliderModal(state, value) {
        state.showSliderModal = value;
    }
};